"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeeringAgentBase = void 0;
class PeeringAgentBase {
    constructor(peerGroupAgent) {
        this.peerGroupAgent = peerGroupAgent;
    }
    receiveLocalEvent(ev) {
        ev;
    }
    getPeerControl() {
        return this.peerGroupAgent;
    }
    sendMessageToPeer(destination, agentId, content) {
        if (content === undefined) {
            throw new Error('Missing message content');
        }
        return this.peerGroupAgent.sendToPeer(destination, agentId, content);
    }
    sendingQueueToPeerIsEmpty(destination) {
        return this.peerGroupAgent.peerSendBufferIsEmpty(destination);
    }
}
exports.PeeringAgentBase = PeeringAgentBase;
//# sourceMappingURL=PeeringAgentBase.js.map